<template>
  <div class="bbe-list-options">
    <div class="bbe-list-options-item"
         v-for="(option, index) in optionsIcons"
         :key="option.icon + index"
         v-if="checkDisplayOption(option)"
         @click.stop="isHeader ? clickHeaderOption(option) : clickOption(option, thread, thread.unread)"
         @mouseenter="option.hover = true"
         @mouseleave="option.hover = false">
      <i class="bbe-list-options-item__icon"
         :class="[
           'email-icon-' + (getIcon(option, thread)),
           option.icon === 'recovery' ? 'bbe-list-options-item__icon_recovery' : '',
           option.icon === 'garbage' ? 'bbe-list-options-item__icon_garbage' : '']"/>
      <transition name="bbe-bounce">
        <div class="bbe-list-options-item-tooltip"
             v-if="option.hover">
          {{isHeader ? option.tooltip : getTitleTooltip(option, thread)}}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {find, get} from 'lodash'

export default {
  name: 'EmailListOptions',
  props: ['isHeader', 'customType', 'checkedMails', 'thread', 'optionAction', 'listEmails'],
  data () {
    return {
      optionsIcons: [
        {
          icon: 'recovery',
          iconActive: 'recovery-active',
          tooltip: 'Move to inbox',
          type: 'moveToInbox',
          hover: false,
          action: this.optionAction.modifyLabels,
          actionHeader: this.optionAction.batchModify,
          visibility: ['TRASH']
        },
        {
          icon: 'mail',
          iconAlt: 'mail-unread',
          iconActive: 'mail-active',
          iconActiveAlt: 'mail-unread-active',
          tooltip: 'Mark as read',
          tooltipAlt: 'Mark as unread',
          type: 'removeUnread',
          typeAlt: 'setUnread',
          hover: false,
          action: this.optionAction.modifyLabels,
          actionHeader: this.optionAction.batchModify,
          visibility: ['INBOX', 'TODO', 'SAVED']
        },
        {
          icon: 'next',
          iconActive: 'next-active',
          tooltip: 'Forward',
          type: 'forward',
          action: this.optionAction.openForwardMessage,
          hover: false,
          visibility: ['INBOX', 'SENT', 'TODO', 'SAVED']
        },
        {
          icon: 'garbage',
          iconActive: 'garbage-active',
          tooltip: 'Delete',
          type: 'moveToTrash',
          hover: false,
          action: this.optionAction.toTrash,
          actionHeader: this.optionAction.batchModify,
          visibility: ['INBOX', 'SENT', 'TODO', 'SAVED', 'DRAFT']
        },
        {
          icon: 'garbage',
          iconActive: 'garbage-active',
          tooltip: 'Delete forever',
          type: 'moveToTrash',
          hover: false,
          action: this.optionAction.deleteThread,
          actionHeader: this.optionAction.batchDelete,
          visibility: ['TRASH']
        }
      ]
    }
  },
  computed: {
    userId () {
      return get(this.activeUser, 'gmail.email', 'me')
    },
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    activeTab () {
      return this.$store.getters.activeTab
    }
  },
  methods: {
    checkDisplayOption (option) {
      const includesTab = option.visibility.includes(this.activeTab)
      if (this.isHeader) {
        return this.checkedMails.length > 1 && includesTab && option.type !== 'forward'
      } else {
        return includesTab
      }
    },
    clickOption (option, thread, unread) {
      option.action({
        userId: this.userId,
        threadId: thread.id,
        type: unread ? option.type : (option.typeAlt || option.type),
        thread
      })
    },
    clickHeaderOption (option) {
      const params = {
        userId: this.userId,
        ids: [],
        type: option.type
      }
      this.checkedMails.forEach(threadId => {
        const thread = find(this.listEmails, {id: threadId})
        if (thread) {
          thread.messages.forEach(message => {
            params.ids.push(message.id)
          })
        }
      })
      option.actionHeader(params)
    },
    getIcon (option, thread) {
      if (this.isHeader) return option.hover ? option.iconActive : option.icon
      const unread = thread.unread || option.type !== 'removeUnread'
      const icon = unread ? option.icon : option.iconAlt
      const iconActive = unread ? option.iconActive : option.iconActiveAlt
      return option.hover ? iconActive : icon
    },
    getTitleTooltip (option, thread) {
      const unread = thread.unread || option.type !== 'removeUnread'
      return unread ? option.tooltip : option.tooltipAlt
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbe-list-options {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: 0;

  &-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: relative;
    margin-right: 12px;
    cursor: pointer;

    &__icon {
      color: $color-silver-chalice;
      font-size: 14px;
      z-index: 2;

      &_recovery {
        font-size: 15px;
      }

      &:before {
        margin: 0;
      }
    }

    &:hover {
      .bbe-list-options-item__icon {
        color: $color-accent;
      }

      .bbe-list-options-item__icon_garbage {
        color: $color-pomegranate;
      }

      &:after {
        width: 26px;
        height: 26px;
      }
    }

    &:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      background-color: $color-gallery;
      border-radius: 50%;
      transition: .2s;
    }

    &:last-child {
      margin-right: 0;
    }

    &-tooltip {
      position: absolute;
      bottom: -31px;
      color: $color-white;
      font-weight: 500;
      font-size: 11px;
      padding: 4px 5px;
      background: rgba($color-black, 0.59);
      border-radius: 3px;
      z-index: 3;
      pointer-events: none;
      user-select: none;
      white-space: nowrap;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Email/EmailList/EmailListOptions/EmailListOptions.vue